import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import { getRegion } from 'utils/Region';
//-----------------------------------------------------------------------------------
import './style.scss';
import { getTranslation, jsonParseTraslation } from 'utils/getTranslation';
import { pushEventFromInputSearch } from 'containers/NewSearchPage/utils/pushEventsFromSearch';
import { IoMdArrowDropup } from 'react-icons/io';
import { getAssets } from 'reducers/responseAsset';

/* Este componente se encarga de realizar la busqueda de contenido en claro video */
const SearchInput = ({ value, onChangeText }) => {
  const assets = useSelector(state => state.asset);
  const searchIcon =
    assets?.search_combo_icon_placeholder_search ||
    'https://clarovideocdn8.clarovideo.net/pregeneracion/cms/apa/uat_531eed34tvfy7b73a818a234/search_menu_option_button_popularSearches.png?1618347183';
  const closeIcon =
    assets?.search_combo_icon_placeholder_close ||
    'https://clarovideocdn6.clarovideo.net/pregeneracion/cms/apa/uat_531eed34tvfy7b73a818a234/home_ticker_icon_button_close.png?1609880814';
  const iconLeft =
    assets?.search_overCarousel_home_icon_surf ||
    'https://clarovideocdn7.clarovideo.net/pregeneracio…search_overCarousel_home_icon_surf.png?1618347253';
  //----Textos del HTML----
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = jsonParseTraslation(texts);
  const keyword = useSelector(state => state.search.searchResults?.keyword);
  const searchTitleLabel = getTranslation(
    'search_default_title_label',
    parseTranslation,
  );
  const searchPlaceholderLabel = getTranslation(
    'search_default_placeHolder_textfield',
    parseTranslation,
  );
  const searchCancelLabel = getTranslation(
    'search_default_cancel_label',
    parseTranslation,
  );

  //Valida que este activo el input para mostrar el boton cancelar y el icono borrar en mobile
  const [activeInput, setActiveInput] = useState(false);

  const handleChange = e => {
    e.target.value.length >= 1 ? setActiveInput(true) : setActiveInput(false);
    onChangeText(e.target.value);
  };

  //Oculta y muestra botones en mobile
  const handleHideClick = () => {
    setActiveInput(false);
    onChangeText('');
  };

  //Limpia texto del input
  const handleClearTextClick = e => {
    onChangeText('');
    setActiveInput(false);
    e.target.previousSibling.focus();
  };

  //Mostrar la keyword previa a una reproducción
  const showKeywordPlayContent = () => {
    if (keyword) {
      onChangeText(keyword);
    }
  };
  //Se utiliza para enviar las metricas
  useEffect(
    () => {
      if (value.length < 3) return;
      pushEventFromInputSearch(value);
    },
    [value],
  );
  useEffect(() => {
    showKeywordPlayContent();
  }, []);

  return <form className="search-input" onSubmit={e => e.preventDefault()}>
      <div className="search-input__field">
        <div className="search-input__content">
          <img alt="prev button" className="search-input__content__image" src={iconLeft} onClick={browserHistory.goBack} />
          <label htmlFor="search-input">{searchTitleLabel}</label>
        </div>
        <div className="search-input__field__input-container">
          <img style={{ position: 'absolute', left: '9px', top: '9px' }} src={searchIcon} height={22} width={22} />
          <input type="text" autoComplete="off" autoFocus={false} name="searchInput" id="search-input" placeholder={`${searchPlaceholderLabel}`} onChange={handleChange} value={value} />
          <img onClick={handleClearTextClick} height={16} width={16} src={closeIcon} className={`search-input-close-icon${activeInput ? '-active' : ''}`} />

          <button className={`${activeInput ? 'search-input__button active' : 'search-input__button'}`} onClick={handleHideClick} type="button">
            {searchCancelLabel}
          </button>
        </div>
      </div> {/* ----Termina primer input---- */}
    </form>;
};

export default SearchInput;
